<template>
  <div>
    <v-dialog v-model="dialog" width="800" persistent scrollable>
      <v-card>
        <AdCardTitle dialog>{{ $t('clone-scenario') }}</AdCardTitle>

        <v-card-text class="mt-6">
          <EditableTreeviewDropdown
            v-model="selectedItem"
            :label="$t('scenario')"
            :tree="treeStructure"
            :filters="filters"
          />
          <div v-if="sourceDatasetInfo.id">
            <span class="pr-3">{{ $t('original-source-dataset') }}</span>
            <AdArtefactDetailsCard :object="sourceDatasetInfo" />
          </div>

        </v-card-text>

        <v-card-actions class="dialogbottomstrip">
          <v-spacer></v-spacer>
          <AdButton type="cancel" @click="close"/>
          <AdButton type="clone" :disabled="!scenarioIsSelected" @click="save"/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EditableTreeviewDropdown from '@/components/Utilities/Editable/EditableDropdown/EditableTreeviewDropdown'

export default {
  name: 'ScenarioTemplateDialog',

  components: {
    EditableTreeviewDropdown
  },

  props: {
    activeItem: {
      type: [String, Object, null],
      required: false,
      default: null
    },
    tree: {
      type: Object,
      required: false,
      default: () => ({})
    },
    filters: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  data () {
    return {
      dialog: false,
      treeStructure: {},
      selectedItem: null
    }
  },

  computed: {
    /**
     * Check if scenario is selected.
     * @returns {boolean}
     */
    scenarioIsSelected () {
      return !!this.selectedItem
    },
    sourceDatasetInfo () {
      return {
        type: 'DS',
        id: this.selectedItem?.representingTemplate?.[0]?.sourceDataset,
        effectiveDate: this.selectedItem?.representingTemplate?.[0]?.sourceDatasetEffectiveDate,
        name: this.selectedItem?.representingTemplate?.[0]?.sourceDatasetName,
        statusCode: this.selectedItem?.representingTemplate?.[0]?.sourceDatasetStatusCode,
        flexibility: this.selectedItem?.representingTemplate?.[0]?.sourceDatasetFlexibility
          ? this.selectedItem?.representingTemplate?.[0]?.sourceDatasetFlexibility
          : 'dynamic'
      }
    }
  },

  watch: {
    activeItem: {
      immediate: true,
      deep: true,
      handler (activeItem) {
        this.selectedItem = activeItem
      }
    },

    tree: {
      immediate: true,
      deep: true,
      handler (tree) {
        this.treeStructure = tree
      }
    }
  },

  methods: {
    /**
     * Open the dialog.
     */
    async open () {
      // Check if user is logged in.
      if (this.isUserLoggedIn === true) {
        // Open dialog.
        this.dialog = true
      }
    },

    /**
     * Close the dialog.
     */
    close () {
      // Close dialog.
      this.dialog = false
    },

    /**
     * Save.
     */
    save () {
      if (this.scenarioIsSelected) {
        let serviceAction = null
        const newScenario = { ...this.selectedItem, id: null }

        if (!this.selectedItem?.type) {
          serviceAction = this.$store.dispatch(
            'scenario/cloneScenarioItem',
            this.selectedItem
          )
        } else {
          // Get matching scenario.
          const matchingScenario = this.$filters.listHelper.getRootElementFromListItem({
            items: this.treeStructure.items,
            children: this.treeStructure.children,
            handler: (match) => match?.id === this.selectedItem?.id && match?.effectiveDate === this.selectedItem?.effectiveDate
          })

          // Get matching parent item.
          const matchingParentItem = this.$filters.listHelper.findItemInList({
            items: this.treeStructure.items,
            children: this.treeStructure.children,
            handler: (match) => {
              let hasMatchingTransactions = false
              if (Array.isArray(match?.transaction)) {
                hasMatchingTransactions = match.transaction.filter((transaction) => {
                  return transaction.id === this.selectedItem?.id &&
                    transaction.effectiveDate === this.selectedItem?.effectiveDate
                }).length > 0
              }

              return hasMatchingTransactions
            }
          })

          if (matchingParentItem) {
            serviceAction = this.$store.dispatch(
              'scenario/cloneScenarioTransactionItem', {
                type: this.selectedItem?.type,
                mode: 'into',
                ref: newScenario?.type !== 'group'
                  ? matchingParentItem?.id
                  : undefined,
                item: this.selectedItem,
                target: matchingScenario
              })
          }
        }

        if (serviceAction) {
          serviceAction.then((response) => {
            if (response?.data) {
              // Close dialog.
              this.close()
              this.$emit('addScenarioFinish', (open) ? response.data : null)
            }
          })
            .catch((error) => {
              const errorMessage = error?.response?.data?.description || error?.response?.statusText || 'Error'
              // Show error message on alert dialog.
              this.$oops(errorMessage)
            })
        }
      }
    }
  }
}
</script>
